export function mergeProps<A, B>(a: A, b: B): B & A
export function mergeProps<A, B, C>(a: A, b: B, c: C): C & B & A
export function mergeProps<A, B, C, D>(a: A, b: B, c: C, d: D): D & C & B & A
export function mergeProps(...items: any[]) {
    const ret: any = {}
    items.forEach(item => {
        if (item) {
            Object.keys(item).forEach(key => {
                if (item[key] !== undefined) {
                    ret[key] = item[key]
                }
            })
        }
    })
    return ret
}

/**
 * Merge props and return the first non-undefined value.
 * The later has higher priority. e.g. (10, 1, 5) => 5 wins.
 * This is useful with legacy props that have been deprecated.
 */
export function mergeProp<T, DefaultT extends T = T>(
    defaultProp: DefaultT,
    ...propList: T[]
): T | undefined {
    for (let i = propList.length - 1; i >= 0; i -= 1) {
        if (propList[i] !== undefined) {
            return propList[i]
        }
    }
    return defaultProp
}